// extracted by mini-css-extract-plugin
export var header = "header-module--header--uughV";
export var container = "header-module--container--ya3Uy";
export var logo = "header-module--logo--wYxsV";
export var toggle = "header-module--toggle--W3Jwk";
export var clock = "header-module--clock--68PGZ";